import token from './token'
import components from './components'

import type { ThemeConfig } from 'antd'

const theme: ThemeConfig = {
  hashed: false,
  token,
  components
}

export default theme
